// extracted by mini-css-extract-plugin
export default {"editor":"CodeEditor_editor__O0spH","codeArea":"CodeEditor_codeArea__g9Xv7","editorLineNumber":"CodeEditor_editorLineNumber__8TRSD"};